<template>
  <el-dialog
      :visible.sync="visible"
      title="销售开票发票号修改"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
      :append-to-body="true"
  >
    <el-form
        ref="dataForm"
        :model="dataForm"
        label-width="120px"
        :rules="dataRule"
    >
      <el-form-item  label="原发票号：">
        {{dataForm.oldCode}}
      </el-form-item>
      <el-form-item prop="receiptCode" label="新发票号：">
       <el-input v-model="dataForm.receiptCode" size="mini"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
          $t('confirm')
        }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import PayDetailSelDialog from '@/views/modules/erp/pay/PayDetailSelDialog.vue'
import BigNumber from 'bignumber.js'
import { isNumber, moneyValidator } from '@/utils/validate'
import debounce from 'lodash/debounce'

export default {
  name:'edit-count-dialog',
  components: {  },
  data () {
    return {
      dataForm: {},
      visible: false,
      dataRule: {
        receiptCode: [
          { required: true, message: '请填写新的发票号', trigger: 'change' },
        ],
      }
    }
  },
  methods: {
    init (data) {
      this.dataForm={
        id:data.id,
        oldCode:data.receiptCode,
        receiptCode:''
      }
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
        function () {
          this.$refs['dataForm'].validate((valid) => {
            if (!valid) {
              return false
            }
            this.$api2.post('/erp/box/edit/code', this.dataForm).then(res => {
              this.saving = false
              this.$emit('change')
              this.$c.success(this.$t('prompt.success')).then(() => {
                this.visible=false
              })
            }).catch(() => {
            })
          })
        },
        1000,
        { leading: true, trailing: false }
    ),
  }
}
</script>

<style scoped>

</style>
